import { computed, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { Feature } from 'src/app/features/feature-management/models';
import { FeatureManagementService } from 'src/app/features/feature-management/services';
import { PackageUsersSelectors } from 'src/app/features/package-users';
import { PackagesSelectors, ProductType } from 'src/app/features/packages';
import { CheckInSelectors } from 'src/app/features/check-in/store';
import { MsalAuthSelectors } from 'src/app/features/msal-auth/store/selectors';
import { ESIGN_HANDOFF_STATE } from 'src/app/features/shared/constants';

@Injectable({
  providedIn: 'root',
})
export class SessionHandoffService {
  private readonly redirectState = this.store.selectSignal(MsalAuthSelectors.getRedirectState);
  private readonly productType = this.store.selectSignal(PackagesSelectors.getProductType);
  private readonly isSigningAgent = this.store.selectSignal(
    PackageUsersSelectors.getIsSigningAgent
  );
  private readonly isRejoining = this.store.selectSignal(CheckInSelectors.isRejoining);

  readonly shouldShowSessionHandoffComponent = computed(() => {
    if (this.redirectState() === ESIGN_HANDOFF_STATE) {
      return true;
    }

    // This check is temporary - can be moved when the new UI state is capable of handling Rejoins
    if (this.isRejoining()) {
      return false;
    }

    // Feature flag check is temporary - can be removed after full launch of join codes
    // Product type / user role check needs to remain for now
    const useSigningJoinCodes = this.featureManagementService.getIsFeatureEnabledWithCaching(
      Feature.UseSigningJoinCodes
    );

    return (
      useSigningJoinCodes &&
      this.productType() === ProductType.RemoteSigning &&
      !this.isSigningAgent()
    );
  });

  constructor(
    private readonly featureManagementService: FeatureManagementService,
    private readonly store: Store
  ) {}
}
